import $ from "jquery";

const voorwaarden = () => {

    const target = ".voorwaarden-container";
    const $target = $(target);

    const init = () => {
        if ($target.length) {
            exec();
        }
    };



    const exec = () => {

        const el = {
            title: '.voorwaarden-container .title-item',
            content : '.voorwaarden-container .content-item'
        }

        $(el.title).filter('#item-1').addClass('active');
        $(el.content).filter('.item-1').addClass('active');

        $(el.title).on('click', function (e) {
            e.preventDefault();
            const titleId = $(this).attr('id');
            $(el.title).removeClass('active');
            $(el.content).removeClass('active');

            $(this).addClass('active')

            $(el.content).filter('.' + titleId).addClass('active');
        })

    };

    init();
};

try {
    voorwaarden();
} catch (error) {
    throw Error(error);
}

